import {z} from '@hono/zod-openapi';

import {VoiceUsageNormalizedTokenCountsSchema} from './VoiceUsageNormalizedTokenCountsSchema';

const reasonSchema = z.enum([
  'missing-usage',
  'missing-details',
  'unknown-rate',
  'conflicting-usage',
  'capacity-exceeded',
  'invalid-usage',
]);
const baseSchema = z
  .object({
    currency: z.literal('USD'),
    model: z.string().min(1).max(128),
    usage: VoiceUsageNormalizedTokenCountsSchema,
  })
  .strict();

export const VoiceDebugSpendProjectionSchema = z
  .discriminatedUnion('status', [
    baseSchema.extend({
      status: z.literal('pending'),
      amount: z.null(),
      rateCardVersion: z.string().min(1).max(64).nullable(),
      lastUsageAt: z.string().datetime({offset: true}).nullable(),
      incompletenessReasons: z.array(reasonSchema).min(1).max(6).readonly(),
    }),
    baseSchema.extend({
      status: z.literal('partial'),
      amount: z.number().finite().nonnegative().nullable(),
      rateCardVersion: z.string().min(1).max(64).nullable(),
      lastUsageAt: z.string().datetime({offset: true}).nullable(),
      incompletenessReasons: z.array(reasonSchema).min(1).max(6).readonly(),
    }),
    baseSchema.extend({
      status: z.literal('unavailable'),
      amount: z.null(),
      rateCardVersion: z.null(),
      lastUsageAt: z.string().datetime({offset: true}).nullable(),
      incompletenessReasons: z.array(reasonSchema).min(1).max(6).readonly(),
    }),
    baseSchema.extend({
      status: z.literal('complete'),
      usage: VoiceUsageNormalizedTokenCountsSchema.refine(
        (usage) => Object.values(usage).every((value) => value !== null),
        {message: 'Complete spend requires every usage count'}
      ),
      amount: z.number().finite().nonnegative(),
      rateCardVersion: z.string().min(1).max(64),
      lastUsageAt: z.string().datetime({offset: true}),
      incompletenessReasons: z.array(reasonSchema).max(0).readonly(),
    }),
  ])
  .openapi('VoiceDebugSpendProjectionSchema');

export type VoiceDebugSpendProjection = z.infer<typeof VoiceDebugSpendProjectionSchema>;
